<template>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialog')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialog"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialog()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <div class="large-12 medium-12 small-12 cell">
            <form ref="form">
              <v-layout row>
                <v-flex xs12>
                  <label class="file-select">
                    <div class="select-button">
                      <span v-if="file.name" class="font-weight-medium subheading">Fichier : {{file.name}}</span>
                      <span class="font-weight-medium subheading" v-else>Choisissez un fichier</span>
                    </div>
                    <input type="file" id="file" @change="handleFileUpload($event)"/>
                  </label>
                </v-flex>
              </v-layout>

              <v-layout
                v-if="file && fileType == 'txt'"
                row wrap
              >
                <v-flex xs12 >
                  {{ $t('AIBaliseDecoup') }}
                  <v-text-field
                    v-model="chunkTag"
                    :label="this.$t('AIBalise')"
                    solo
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout
                v-else-if="file && fileType == 'pdf' || fileType == 'image' || fileType == 'docx' || fileType == 'pptx'"
                row wrap
              >
                <v-flex xs12 md12>
                  <v-switch
                    v-model="resumePDF"
                    :label="`Résumé : ${resumePDF.toString()}`"
                  ></v-switch>
                </v-flex>

                <v-flex v-if="!resumePDF" xs12 md12>
                  {{ $t('AINumSeg') }} {{chunkCar}}
                  <v-slider
                  v-model="chunkCar"
                  :max="chunkCarMax"
                  :min="chunkCarMin"
                  step="1000"
                  thumb-label
                  ticks
                  ></v-slider>
                  <v-text-field
                    v-model="chunkCar"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex v-else xs12 md12>
                  <v-textarea
                    v-model="promptResume"
                    auto-grow
                    box
                    name="input-7-1"
                    label="Default style"
                    hint="Hint text"
                  ></v-textarea>
                </v-flex>

              </v-layout>

            </form>
          </div> 
          <v-alert
            outline
            v-if="alertReturn"
            :value="true"
            :type="alertType"
          >
            {{ textReturn }}
          </v-alert>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('close') }}</v-btn>
          <v-btn 
            :loading="loadingFile"
            :disabled="loadingFile || desabledBTN"
            color="primary"
            @click="saveRedisFile()"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>



<script>
import { mapState } from 'vuex'
import FormData from 'form-data'

export default {
  props: {
    titleDialog: {
      type: String,
      default: 'Confirmation'
    },
    afficheDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      resumePDF: true,
      file: [],
      contentDialog: '',
      loadingFile: false,
      updatedKeywords: false,
      alertReturn: false,
      alertType: 'success',
      textReturn: '',
      chunkCar: 50000,
      chunkCarMax: 1000000,
      chunkCarMin: 1000,
      chunkTag: '',
      fileType: 'txt',
      promptResume: `
        Écris en français un court résumé reprenant tous les points importants du document délimité par ###.
        Structure attendue :
        @ résumé
        @ type de document
        @ titre du document
        @ code magasin
        @ date du document
      `
    }
  },
  computed: {
    ...mapState('_Sites', ['sites', 'siteSelected']),
    // url du bon serveur (prod / dev)
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-generator-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-generator-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-generator.watcheebox.net/'
      } else {
        return 'https://lb-sw-generator.watcheebox.net/'
      }
    },
    desabledBTN () {
      if (this.file.name) {
        console.log('length false')
        return false
      } else {
        console.log('length true')
        return true
      }
    }
  },
  mounted () {},
  updated () {},
  methods: {
    handleFileUpload (event) {
      console.log('handleFileUpload', this.fileType)
      const file = event.target.files[0]
      if (!file) return

      // Normalisation Unicode pour garder les accents
      const normalizedName = file.name.normalize('NFC')
      this.file = new File([file], normalizedName, { type: file.type })

      const name = this.file.name.toLowerCase()
      console.log('name', name)
      const type = this.file.type
      console.log('type', type)

      if (type === 'application/pdf' || name.endsWith('.pdf')) {
        this.fileType = 'pdf'
      } else if (type === 'text/csv' || name.endsWith('.csv')) {
        this.fileType = 'csv'
      } else if (type === 'text/plain' || name.endsWith('.txt')) {
        this.fileType = 'txt'
        this.resumePDF = false
      } else if (type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || name.endsWith('.docx')) {
        this.fileType = 'docx'
      } else if (type === 'application/msword' || name.endsWith('.doc')) {
        this.fileType = 'doc'
      } else if (type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || name.endsWith('.pptx')) {
        this.fileType = 'pptx'
      } else if (type.startsWith('image/')) {
        this.fileType = 'image'
      } else {
        this.fileType = 'unknown'
      }

      console.log('fileType', this.fileType)
    },
    closeDialog () {
      this.$emit('justCloseDialog')
      this.resetFile()
      this.alertReturn = false
    },
    // efface le fichier selectionné
    resetFile () {
      this.file = {}
      this.$refs.form.reset()
    },
    // enregistre dans redis le embedding du fichier pdf
    // async saveRedisPdf (file) {
    //   this.loadingFile = true
    //   // console.log('this.faqDialog', this.faqDialog)
    //   // this.showDialogModifKeyword = true
    //   // console.log('open keyword', data)
    //   let formData = new FormData()
    //   formData.append('file', this.file)
    //   formData.append('chunkTag', this.chunkTag)
    //   formData.append('chunkCar', this.chunkCar)
    //   formData.append('licKey', this.siteSelected.LIC_KEY)
    //   this.axios.post(this.serveurAI + 'savePDF',
    //   formData,
    //     {headers: {'Content-Type': 'multipart/form-data'}}
    //   ).then((res) => {
    //     // console.log('res retour', res)
    //     if (res.data.retour === 1) {
    //       // console.log('SUCCESS!!', res.data.data)
    //       this.$emit('addFile', res.data.data)
    //       this.textReturn = res.data.info
    //       this.loadingFile = false
    //       this.alertReturn = true
    //       this.alertType = 'success'
    //       this.resetFile()
    //     } else {
    //       // console.log('erreur...')
    //       this.textReturn = res.data.info
    //       this.loadingFile = false
    //       this.alertReturn = true
    //       this.alertType = 'error'
    //     }
    //   })
    //   .catch((error) => {
    //     // console.log('FAILURE!!', error)
    //     this.textReturn = error
    //     this.loadingFile = false
    //     this.alertReturn = true
    //     this.alertType = 'error'
    //   })
    // },
    // enregistre dans redis le embedding du fichier
    saveRedisFile () {
      if (this.resumePDF) {
        // si c'est un résumé de pdf
        console.log('création du résumé PDF', this.file)
        this.loadingFile = true
        let formData = new FormData()
        formData.append('model', 'mistral-large-latest') // pour tester mais cela doit etre parametrable
        formData.append('file', this.file)
        formData.append('promptResume', this.promptResume)
        formData.append('licKey', this.siteSelected.LIC_KEY)
        this.axios.post(this.serveurAI + 'resumeFile',
        formData,
          {headers: {'Content-Type': 'multipart/form-data'}}
        )
        .then((res) => {
          // console.log('res retour', res)
          if (res.data.retour === 1) {
            // console.log('SUCCESS!!', res.data.data)
            // this.$emit('resumeFile', res.data.data)
            this.textReturn = res.data.info
            this.loadingFile = false
            this.alertReturn = true
            this.alertType = 'success'
            this.resetFile()
            this.$emit('addFile', res.data.name)
          } else {
            // console.log('erreur...')
            this.textReturn = res.data.info
            this.loadingFile = false
            this.alertReturn = true
            this.alertType = 'error'
          }
        })
        .catch((error) => {
          // console.log('FAILURE!!', error)
          this.textReturn = error
          this.loadingFile = false
          this.alertReturn = true
          this.alertType = 'error'
        })
      } else {
        // ou un chunk de pdf
        this.loadingFile = true
        // 2 actions possible, 'saveFile' ou 'savePDF'
        console.log('type de fichier : ', this.file)
        // this.showDialogModifKeyword = true
        // console.log('open keyword', data)
        let formData = new FormData()
        formData.append('file', this.file)
        formData.append('chunkTag', this.chunkTag)
        formData.append('chunkCar', this.chunkCar)
        formData.append('licKey', this.siteSelected.LIC_KEY)
        this.axios.post(this.serveurAI + 'saveFile',
        formData,
          {headers: {'Content-Type': 'multipart/form-data'}}
        )
        .then((res) => {
          console.log('saveRedisFileres retour', res)
          if (res.data.retour === 1) {
            // console.log('SUCCESS!!', res.data.data)
            this.$emit('addFile', res.data.data)
            this.textReturn = res.data.info
            this.loadingFile = false
            this.alertReturn = true
            this.alertType = 'success'
            this.resetFile()
          } else {
            // console.log('erreur...')
            this.textReturn = res.data.info
            this.loadingFile = false
            this.alertReturn = true
            this.alertType = 'error'
          }
        })
        .catch((error) => {
          // console.log('FAILURE!!', error)
          this.textReturn = error
          this.loadingFile = false
          this.alertReturn = true
          this.alertType = 'error'
        })
      }
    }
  },
  watch: {
    // detect quand la dialogBow est effichée
    afficheDialog: function (val, oldVal) {
      console.log('afficheDialog val :', val)
      if (val) {
        // this.openDialogUpdateKeyword(this.dataDialog)
      }
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .file-select > .select-button {
    padding: 1rem;
    color: white;
    background-color: #2EA169;
    border-radius: .3rem;
    text-align: center;
    /* font-weight: bold; */
    cursor: pointer;
  }
  .file-select > input[type="file"] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogImportPDF.vue